function reloadStampedBadges() {
  // Check if StampedFn exists
  if (typeof StampedFn !== 'undefined') {
    // Reload just the badges
    StampedFn.loadBadges();

    console.log('loadBadges');
  } else {
    console.error('StampedFn not found. Make sure stamped-widget.min.js is loaded first.');
  }
}

// Export the function so it can be used globally
window.reloadStampedBadges = reloadStampedBadges;

/*


var $ = jQuery.noConflict();

$(function(){
$('body').on('click', function() {
    

    reloadStampedBadges();
    
    console.log('reloadStampedBadges()');

    //function myInit(){ StampedFn.init({ apiKey: '5336c169-f32a-40aa-a750-085547269d4f', sId: '326449' }); }
    
    console.log('stamped  myInit() ');
 
 
})


}) // document ready
*/